import { render, staticRenderFns } from "./QuailTriathlon.vue?vue&type=template&id=0fc02e5a&scoped=true&"
import script from "./QuailTriathlon.vue?vue&type=script&lang=js&"
export * from "./QuailTriathlon.vue?vue&type=script&lang=js&"
import style0 from "./QuailTriathlon.vue?vue&type=style&index=0&id=0fc02e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc02e5a",
  null
  
)

export default component.exports